export const actionTypes = {
    APP_LOAD: "appLoad",
    SAVE_LOGIN: "saveLogin",
    CLEAR_LOGIN: "clearLogin",
    CHECK_TOKEN: "checkToken",
    LOAD_LOCATION: "loadLocation",
    LOAD_USER_DATA: "loadUserData",
    SAVE_DATA: "saveData",
};

export const commitTypes = {
    SET_USER: "setUser",
    SET_SETTINGS: "setSettings",
    SET_REDIRECT: "setRedirect",
    SET_STATE: "setState",
    SET_USER_PROFILE: "setUserProfile",
};


export const dbName = {
    DB_STATE: "state",
};

export const getterTypes = {};